<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsDialog',
  
})
</script>
<template>
  <t-dialog>
    <slot />
  </t-dialog>
</template>

<script setup lang="ts" name="TlbsDialog">
// interface Props {
//   header?: string;
// }
//
// withDefaults(defineProps<Props>(), {
//   header: '',
// });
</script>
